import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import {
  IParseCreatorsCsvRequest,
  IParseEditCreatorsGoogleSheetRequest,
} from "@shared/lib/types/brief";
import { BriefService } from "../services/brief.service";

export function useParseEditCreatorsCsv(
  handleSuccess?: (data: IParseEditCreatorsGoogleSheetRequest[]) => void
) {
  const {
    mutate: parseEditCreatorsCsv,
    isLoading: isParsingEditCreatorsCsv,
    isSuccess: isParsedEditCreatorsCsv,
    data,
  } = useMutation<
    IParseCreatorsCsvRequest,
    BackednResponse<IParseEditCreatorsGoogleSheetRequest[]>
  >({
    mutationFn: (payload) =>
      BriefService.parseEditCreatorsCsv(payload).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (_c, response) => {
      handleSuccess?.(response.data);
    },
  });

  return {
    parseEditCreatorsCsv,
    isParsingEditCreatorsCsv,
    isParsedEditCreatorsCsv,
    parsedRows: data?.data ?? [],
  };
}
